/** Multiword location names that should never wrap mid-name in the Hero Capsule heading. */
const NON_BREAKING_LOCATION_NAMES = [
  "New York City",
  "Los Angeles",
  "Washington D.C."
]

const NON_BREAKING_SPACE = " "

/**
 * Replaces spaces in known multiword location names with non-breaking spaces
 * so they can't be split across lines when the heading wraps.
 */
export function withNonBreakingLocationNames(heading: string): string {
  return NON_BREAKING_LOCATION_NAMES.reduce(
    (result, locationName) =>
      result
        .split(locationName)
        .join(locationName.split(" ").join(NON_BREAKING_SPACE)),
    heading
  )
}
